module.exports = __webpack_public_path__ + "img/fertility-future.6c98e948.svg";